import React, { Component, Fragment } from "react";
import { reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { renderTextField, renderSelect, renderCheckbox } from "../../../../ReduxFormAdapters";
import { MenuItem, Typography } from "@material-ui/core";
import DateField from "../../../../Helpers/DateField";
import LocationFields from "../../../../SignUp/LocationFields";
import FieldValidationProvider from "../../../../Helpers/FieldValidator/FieldValidationProvider";
import ValidatedField from "../../../../Helpers/FieldValidator/ValidatedField";

class PropertiesEditForm extends Component {

    static propTypes = {
        handleSubmit: PropTypes.func.isRequired
    }

    render() {
        const { landlord, handleSubmit, form, dispatch, validity } = this.props;
        const tenant = !landlord;
        return (
            <FieldValidationProvider validity={validity || {}}>
                <form className="Content-form" onSubmit={handleSubmit}>
                    <Typography
                        variant="h6"
                        color="secondary"
                        align="left"
                    >
                        Address
                    </Typography>
                    <LocationFields
                        form={form}
                        tenant={tenant}
                        dispatch={dispatch}
                    />
                    <div className="Content-options">
                        {tenant &&
                            <div>
                                <Typography
                                    variant="h6"
                                    color="secondary"
                                    align="left"
                                >
                                    Property types*
                                </Typography>
                                <div className="ApartmentForm-column">
                                    <ValidatedField
                                        component={renderCheckbox}
                                        color="primary"
                                        name="residenceType.GARAGE"
                                        label="Garage"
                                    />
                                    <ValidatedField
                                        component={renderCheckbox}
                                        color="primary"
                                        name="residenceType.OFFICE"
                                        label="Office"
                                    />
                                    <ValidatedField
                                        component={renderCheckbox}
                                        color="primary"
                                        name="residenceType.ATELIER"
                                        label="Atelier"
                                    />
                                    <ValidatedField
                                        component={renderCheckbox}
                                        color="primary"
                                        name="residenceType.SEWING_WORKSHOP"
                                        label="Sewing workshop"
                                    />
                                    <ValidatedField
                                        component={renderCheckbox}
                                        color="primary"
                                        name="residenceType.CAR_WORKSHOP"
                                        label="Car workshop"
                                    />
                                    <ValidatedField
                                        component={renderCheckbox}
                                        color="primary"
                                        name="residenceType.MASSAGE_WORKSHOP"
                                        label="Massage workshop"
                                    />
                                    <ValidatedField
                                        component={renderCheckbox}
                                        color="primary"
                                        name="residenceType.PRODUCTION_HALL"
                                        label="Production hall"
                                    />
                                </div>
                            </div>
                        }
                    </div>
                    <div className="Content-options">
                        <div>
                            <Typography
                                variant="h6"
                                color="secondary"
                                align="left"
                            >
                                Move in Date*
                            </Typography>
                            <DateField
                                name="whenAvailable"
                                form={form}
                                min={Date.now()}
                            />
                        </div>
                        <div>
                            <Typography
                                variant="h6"
                                color="secondary"
                                align="left"
                            >
                                Move out Date
                            </Typography>
                            <DateField
                                name="moveOutDate"
                                form={form}
                                min={Date.now()}
                            />
                        </div>
                    </div>
                    <div className="Content-options">
                        <div>
                            <Typography
                                variant="h6"
                                color="secondary"
                                align="left"
                            >
                                Rent per Month*
                            </Typography>
                            {tenant &&
                                <Fragment>
                                    <div className="ApartmentForm-row">
                                        <ValidatedField
                                            name="rentMin"
                                            component={renderTextField}
                                            variant="outlined"
                                            color="secondary"
                                            required
                                            type="text"
                                            placeholder="Min €"
                                        />
                                        &nbsp;&mdash;&nbsp;
                                        <ValidatedField
                                            name="rentMax"
                                            component={renderTextField}
                                            variant="outlined"
                                            color="secondary"
                                            required
                                            type="text"
                                            placeholder="Max €"
                                        />
                                    </div>
                                </Fragment>
                            }
                            {landlord &&
                                <ValidatedField
                                    name="rentMin"
                                    component={renderTextField}
                                    variant="outlined"
                                    color="secondary"
                                    required
                                    type="text"
                                    placeholder="€"
                                />
                            }
                        </div>
                        <div>
                            <Typography
                                variant="h6"
                                color="secondary"
                                align="left"
                            >
                                {/* Size (m&sup2;)* */}
                                Size*
                            </Typography>
                            <div className="ApartmentForm-row">
                                {tenant &&
                                    <Fragment>
                                        <ValidatedField
                                            name="sizeMin"
                                            component={renderTextField}
                                            variant="outlined"
                                            color="secondary"
                                            required
                                            type="text"
                                            placeholder="Min m²"
                                        />
                                        &nbsp;&mdash;&nbsp;
                                        <ValidatedField
                                            name="sizeMax"
                                            component={renderTextField}
                                            variant="outlined"
                                            color="secondary"
                                            required
                                            type="text"
                                            placeholder="Max m²"
                                        />
                                    </Fragment>
                                }
                                {landlord &&
                                    <ValidatedField
                                        name="sizeMin"
                                        component={renderTextField}
                                        variant="outlined"
                                        color="secondary"
                                        required
                                        type="text"
                                        placeholder="m²"
                                    />
                                }
                            </div>
                        </div>

                    </div>
                    <Typography
                        variant="h6"
                        color="secondary"
                        align="left"
                    >
                        Property Characteristics
                    </Typography>
                    <div className="Content-options">
                        <div>
                            <div className="ApartmentForm-column">
                                <ValidatedField
                                    component={renderCheckbox}
                                    color="primary"
                                    name="kitchen"
                                    label="Kitchen"
                                />
                                <ValidatedField
                                    component={renderCheckbox}
                                    color="primary"
                                    name="wc"
                                    label="Wc"
                                />
                                <ValidatedField
                                    component={renderCheckbox}
                                    color="primary"
                                    name="shower"
                                    label="Shower"
                                />
                                <ValidatedField
                                    component={renderCheckbox}
                                    color="primary"
                                    name="breakRoom"
                                    label="Break Room"
                                />
                                <ValidatedField
                                    component={renderCheckbox}
                                    color="primary"
                                    name="parking"
                                    label="Parking"
                                />
                            </div>
                        </div>
                        <div>
                            <div className="ApartmentForm-column">
                            </div>
                        </div>
                    </div>
                    {landlord &&
                        <Fragment>
                            <Typography
                                variant="body1"
                                color="secondary"
                            >
                                Please Write a Short Description About the Apartment Below
                            </Typography>
                            <ValidatedField
                                name="description"
                                component={renderTextField}
                                multiline
                                margin="normal"
                                rowsMax="3"
                                type="text"
                            />
                            <ValidatedField
                                name="industries"
                                component={renderSelect}
                                multiple
                                label="Industry*"
                                required
                            >
                                <MenuItem disabled value="">Select Your Preferable Industry Type</MenuItem>
                                <MenuItem value="mn">Manufacturing</MenuItem>
                                <MenuItem value="fi">Financial services</MenuItem>
                                <MenuItem value="tr">Transportation</MenuItem>
                                <MenuItem value="ed">Education</MenuItem>
                                <MenuItem value="ti">Tiertiary Industry</MenuItem>
                                <MenuItem value="hc">Health Care</MenuItem>
                                <MenuItem value="ht">Hospitality</MenuItem>
                                <MenuItem value="mi">Media Industry</MenuItem>
                                <MenuItem value="ot">Other</MenuItem>
                            </ValidatedField>
                            <ValidatedField
                                multiple
                                name="creditRating"
                                component={renderSelect}
                                label="Credit rating"
                            >
                                <MenuItem disabled value="">
                                    Select preferred credit rating
                                </MenuItem>
                                <MenuItem value="aaa">AAA (Prime)</MenuItem>
                                <MenuItem value="aa">AA (High grade)</MenuItem>
                                <MenuItem value="a">A (Upper medium grade)</MenuItem>
                                <MenuItem value="bbb">BBB (Lower medium grade)</MenuItem>
                                <MenuItem value="bb">BB (Speculative)</MenuItem>
                                <MenuItem value="b">B (Highly speculative)</MenuItem>
                                <MenuItem value="c">C (Substantial risks)</MenuItem>
                                <MenuItem value="d">D (In default)</MenuItem>
                            </ValidatedField>
                            {/* <ValidatedField
                                name="occupation"
                                component={renderSelect}
                                multiple
                                label="Occupation"
                            >
                                <MenuItem disabled value="">Select preferred occupation, if any</MenuItem>
                                <MenuItem value="work">Working</MenuItem>
                                <MenuItem value="student">Student</MenuItem>
                            </ValidatedField> */}
                            <ValidatedField
                                multiple
                                name="operatingMargin"
                                component={renderSelect}
                                label="Operating margin"
                            >
                                <MenuItem value="">
                                    Specify your operating margin in dollar($)
                                </MenuItem>
                                <MenuItem value="negative">Negative</MenuItem>
                                <MenuItem value="postitive">1-10000 $</MenuItem>
                                <MenuItem value="higher">10000+ $</MenuItem>
                            </ValidatedField>
                            <ValidatedField
                                multiple
                                name="employee"
                                component={renderSelect}
                                label="No. of employee"
                            >
                                <MenuItem disabled value="">
                                    How many employee is the workspace for?
                                </MenuItem>
                                <MenuItem value={0}>1</MenuItem>
                                <MenuItem value={1}>2</MenuItem>
                                <MenuItem value={2}>3-4</MenuItem>
                                <MenuItem value={3}>5-9</MenuItem>
                                <MenuItem value={4}>10-19</MenuItem>
                                <MenuItem value={5}>20-49</MenuItem>
                                <MenuItem value={6}>50-99</MenuItem>
                                <MenuItem value={7}>100+</MenuItem>
                            </ValidatedField>
                        </Fragment>
                    }
                </form>
            </FieldValidationProvider>
        );
    }

}

PropertiesEditForm = connect(
    (state, ownProps) => {
        const selector = formValueSelector(ownProps.form || (ownProps.landlord ? "landlordSignup" : "signup"));
        const occupation = selector(state, "occupation");
        return {
            working: occupation
                ? (Array.isArray(occupation)
                    ? occupation.includes("work")
                    : (occupation.work ? true : false))
                : false,
            student: occupation
                ? (Array.isArray(occupation)
                    ? occupation.includes("student")
                    : (occupation.student ? true : false))
                : false,
            ...ownProps
        }
    },
    dispatch => ({
        dispatch: dispatch
    })
)(PropertiesEditForm);

export default reduxForm({
    form: "propertiesEdit"
})(PropertiesEditForm);